// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  FETCH_SECTORS_REQUEST,
  DELETE_SECTORS_REQUEST,
  FETCH_SECTOR_REQUEST,
  UPDATE_SECTORS_REQUEST,
  FETCH_SECTORS_RELEASE_REQUEST,
  OPEN_EDIT_PAGE_SECTOR,
} from './actionTypes';
import {
  fetchSectorsSuccess,
  fetchSectorsFailure,
  deleteSectorSuccess,
  deleteSectorFailure,
  fetchSectorSuccess,
  fetchSectorFailure,
  updateSectorSuccess,
  updateSectorFailure,
  fetchSectorsReleaseSuccess,
  fetchSectorsReleaseFailure,
  openEditPageSectorSuccess,
} from './actions';
import { deleteSector, getAllSectors, getSector, updateSector } from '../../helpers/backend_helper';
import { reduxSerializedError } from '../../utils/utils';

function* fetchSectorsSaga() {
  try {
    const response = yield call(getAllSectors);
    yield put(fetchSectorsSuccess(response));
  } catch (error) {
    yield put(fetchSectorsFailure(reduxSerializedError(error)));
  }
}

function* fetchSectorsReleaseSaga() {
  try {
    const response = yield call(getAllSectorsRelease);
    yield put(fetchSectorsReleaseSuccess(response));
  } catch (error) {
    yield put(fetchSectorsReleaseFailure(reduxSerializedError(error)));
  }
}

function* fetchSectorSaga({ payload }) {
  try {
    const response = yield call(getSector, payload);
    yield put(fetchSectorSuccess(response));
  } catch (error) {
    yield put(fetchSectorFailure(reduxSerializedError(error)));
  }
}

function* deleteSectorsSaga({ payload }) {
  try {
    yield call(deleteSector, payload);
    yield put(deleteSectorSuccess(payload));
    yield call(fetchSectorsSaga); // Refresh the sector list
  } catch (error) {
    yield put(deleteSectorFailure(reduxSerializedError(error)));
  }
}

function* updateSectorSaga({ payload }) {
  const { sector, navigate } = payload;
  try {
    yield call(updateSector, sector);
    yield put(updateSectorSuccess());
    navigate('/sectors');
    yield call(fetchSectorsSaga); // Refresh the sector list
  } catch (error) {
    yield put(updateSectorFailure(reduxSerializedError(error)));
  }
}

function* openEditPageSectorSaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/sectors/${id}`);
    yield put(openEditPageSectorSuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}


export default function* rootSaga() {
  yield takeEvery(FETCH_SECTORS_REQUEST, fetchSectorsSaga);
  yield takeEvery(FETCH_SECTORS_RELEASE_REQUEST, fetchSectorsReleaseSaga);
  yield takeEvery(FETCH_SECTOR_REQUEST, fetchSectorSaga);
  yield takeEvery(UPDATE_SECTORS_REQUEST, updateSectorSaga);
  yield takeEvery(DELETE_SECTORS_REQUEST, deleteSectorsSaga);
  yield takeEvery(OPEN_EDIT_PAGE_SECTOR, openEditPageSectorSaga);
}
